module.exports = __webpack_public_path__ + "img/cjcl4.3ea4e08a.png";